import { render, staticRenderFns } from "./RmDistributorMaintain.vue?vue&type=template&id=c6612a34&scoped=true"
import script from "./RmDistributorMaintain.vue?vue&type=script&lang=js"
export * from "./RmDistributorMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6612a34",
  null
  
)

export default component.exports